<template>
  <div 
    @mouseout="isMouseOver = false" 
    @mouseover="isMouseOver = true"
    :class="{'shake':shake, 
             'show': isVisible, 
             'info': intent == 'info',
             'error': intent == 'error', 
             'success': intent == 'success',
             'warning': intent == 'warning'}" 
    class="sToast">
    <div>
      
      <v-layout 
        row 
        align-center 
        justify-center
        style="margin: 0 0 0 15px;"
      >
        <v-btn v-if="!$vuetify.breakpoint.xsOnly"
          v-show="!noClose"
          @click="hide" 
          class="close-toast" 
          text 
          icon 
          color="white">
          <v-icon>close</v-icon>
        </v-btn>
        <div class="mr-2">
          <v-icon 
            v-show="intent == 'info'" 
            class="intent">info</v-icon>
          <v-icon 
            v-show="intent == 'warning'" 
            class="intent" color="white">info</v-icon>
          <v-icon 
            v-show="intent == 'error'" 
            class="intent">error</v-icon>
          <v-icon 
            v-show="intent == 'success'" 
            class="intent">check_circle</v-icon>
        </div>
        <div id="message">{{ message }}</div>
      </v-layout>
      <div 
        v-if="toShowProgress"
        class="progress" 
        :style="progressBarStyle"></div>
    </div>
  </div>
</template>

<style>
.sToast {
  z-index: 1000;
  position: fixed;
  bottom: -500px;
  width: 100%;
  min-height: 44px;
  height:auto;
  transition: all 0.3s ease;
  box-shadow: 0 3px 12px 1px rgba(0, 0, 0, 1);
}

.sToast.show {
  bottom: 0;
}

.sToast > div {
  padding: 10px;
  padding-right: 30px;
  height: 100%;
}

.sToast.error > div {
  background-color: #f55252;
}

.sToast.info > div {
  background-color: #1eace2;
}

.sToast.success > div {
  background-color: #01e471;
}

.sToast.warning > div {
  background-color: #fb8c00;
}

.sToast i.intent {
  font-size: 22px;
  height: 22px;
  width: 22px;
  color: white;
}

.sToast #message {
  font-size: 18px;
  color: white;
   
}

.sToast .close-toast {
  position: absolute;
  right: 4px;
  top: -1px;
  color: white;
  cursor: pointer;
}

.sToast .progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  width: 100%;
  border-radius: 3px;
  background: white;
}

@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
}

.shake {
  animation-name: shake;
  animation-duration: 1s;
  animation-fill-mode: both;
}
</style>

<script>
import sToast from "./sToast.ts";
export default sToast;
</script>
